import styled from 'foundations-theming/utils';
import { toPercent } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const BORDER_WIDTH_BY_SIZE = {
  md: '100',
  lg: '200'
};
const MARGIN_BY_SIZE = {
  md: '25',
  lg: '50'
};
export const getTrackColorTokenFromProps = ({
  value,
  disabled,
  restricted,
  readOnly
}) => {
  if (value <= 0) {
    if (disabled || readOnly) {
      return 'border-core-subtle';
    }
    if (!restricted) {
      return 'icon-interactive-default';
    }
  }
  return 'border-core-default';
};
const StyledSliderTrackSegmentContainer = styled.div.withConfig({
  displayName: "SliderTrackSegment__StyledSliderTrackSegmentContainer",
  componentId: "sc-14glpt7-0"
})(({
  $insetInlineStart,
  $inlineSize,
  $cursor,
  theme
}) => {
  return {
    position: 'absolute',
    insetBlockStart: theme.space[0],
    insetBlockEnd: theme.space[0],
    insetInlineStart: toPercent($insetInlineStart),
    inlineSize: toPercent($inlineSize),
    cursor: $cursor
  };
});
const StyledSliderTrackSegment = styled.div.withConfig({
  displayName: "SliderTrackSegment__StyledSliderTrackSegment",
  componentId: "sc-14glpt7-1"
})(({
  $restricted,
  $value,
  $size,
  $disabled,
  $readOnly,
  theme
}) => {
  return {
    borderColor: theme.color[getTrackColorTokenFromProps({
      value: $value,
      disabled: $disabled,
      restricted: $restricted,
      readOnly: $readOnly
    })],
    borderStyle: $restricted ? 'dashed' : 'solid',
    borderWidth: theme.borderWidth[BORDER_WIDTH_BY_SIZE[$size] || '0'],
    position: 'absolute',
    insetBlockStart: $size === 'lg' ? '8px' : '6px',
    insetInlineStart: theme.space['0'],
    insetInlineEnd: theme.space['0'],
    marginBlockStart: theme.space['0'],
    marginInlineStart: theme.space[MARGIN_BY_SIZE[$size] || '0'],
    marginBlockEnd: theme.space['0'],
    marginInlineEnd: theme.space['0']
  };
});
export const SliderTrackSegment = ({
  size = 'md',
  restricted = false,
  disabled = false,
  readOnly,
  left,
  width,
  value = 0
}) => {
  return /*#__PURE__*/_jsx(StyledSliderTrackSegmentContainer, {
    $insetInlineStart: left,
    $inlineSize: width,
    $cursor: restricted || disabled ? 'not-allowed' : undefined,
    children: /*#__PURE__*/_jsx(StyledSliderTrackSegment, {
      $restricted: restricted,
      $value: value,
      $size: size,
      $disabled: disabled,
      $readOnly: readOnly,
      "data-slider-track-number": value
    })
  });
};